import React from 'react';
import { Route } from 'react-router-dom';
import ProfileEdit from "./components/Profile/ProfileEdit";
import { AboutAppShow } from "./components/AboutApp";

export default [
    <Route key="Profile" path="/Profile" component={props => <ProfileEdit {...props} />} />,
    <Route key="AboutApp" path="/About" component={props => <AboutAppShow {...props} />} />,
];